import { Result } from "@pankod/refine-antd";

export const AppError = <Result
    status="403"
    title="403: Not Authorized"
    subTitle="Sorry, you are not authorized to access this page. Please contact TCS Microsoft PMO Team (tcsmspmo@microsoft.com) to request access."
/>;
